export default "__VITE_ASSET__BG0D0mKe__"